import { CommonModule } from '@angular/common';
import { Component, inject, input, OnInit, output, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DropdownComponent } from 'src/app/components/shared/dropdown/dropdown.component';
import { AddResumeEmployment } from 'src/app/models/resume/add-resume';
import { DropDownKeywords, DropdownOption } from 'src/app/models/shared/dropdown-option';
import { DropdownService } from 'src/app/services/dropdown.service';
import { ResumeService } from 'src/app/services/resume.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-employment',
  imports: [CommonModule, ReactiveFormsModule, DropdownComponent],
  templateUrl: './modal-employment.component.html',
  styleUrl: './modal-employment.component.css'
})
export class ModalEmploymentComponent implements OnInit {
  public resumeId = input<number | null>(null);
  public onResumeEmployment = output<AddResumeEmployment>();

  private readonly resumeService = inject(ResumeService);
  private readonly dropdownService = inject(DropdownService);

  public form = new FormGroup({
    id: new FormControl(0),
    resumeId: new FormControl(0),
    companyId:  new FormControl(null, [Validators.required]),
    company: new FormControl('', [Validators.maxLength(1000)]),
    positionId: new FormControl(null, [Validators.required]),
    position: new FormControl('', [Validators.maxLength(1000)]),
    startDate: new FormControl(null, [Validators.required]),
    endDate: new FormControl(null),
    currentJob: new FormControl(false),
    salaryExpectationId: new FormControl(null),
    responsibility: new FormControl('', [Validators.maxLength(1000)]),
    achievement: new FormControl('', [Validators.maxLength(1000)]),
    isEnabled: new FormControl(true)
  });

  positions: DropdownOption[] = [];
  companies: DropdownOption[] = [];
  salaryExpectationOptions: DropdownOption[] = [];

  isLoading = signal<boolean>(false);

  ngOnInit(): void {
    this.getOptions();
  }

  getOptions() {
    this.dropdownService.GetOptions(DropDownKeywords.Positions,null,undefined,true).subscribe({
      next: res => {
        this.positions = res;
      }
    });
    this.dropdownService.GetOptions(DropDownKeywords.Companies,null,undefined,true).subscribe({
      next: res => {
        this.companies = res;
      }
    });
    this.dropdownService.GetOptions(DropDownKeywords.SalaryExpectations,null,undefined,true).subscribe({
      next: res => {
        this.salaryExpectationOptions = res;
      }
    });
  }

  reset() {
    this.form.reset();
    this.form.patchValue({
      currentJob: false,
      isEnabled: true
    });
    this.changeCurrentJob();
  }

  changeCurrentJob(){
    const currentJob = this.form.get('currentJob')?.value ?? false;
    if(!currentJob){
      this.form.get('endDate')?.enable();
      this.form.get('endDate')?.setValidators([Validators.required]);
    }else{
      this.form.get('endDate')?.setValue(null);
      this.form.get('endDate')?.disable();
      this.form.get('endDate')?.clearValidators();
    }
    this.form.get('endDate')?.updateValueAndValidity();
  }

  closeModal() {
    this.reset();
    let divModal = document.getElementById('modalExperienciaLaboral');
    let modal = (window as any).bootstrap.Modal.getInstance(divModal);
    modal.hide();
  }

  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const resumeEmployment = {
      ...this.form.getRawValue(),
      position: this.positions?.find(position => position.id == this.form.getRawValue().positionId)?.text,
      company: this.companies?.find(company => company.id == this.form.getRawValue().companyId)?.text,
      endDate: this.form.getRawValue().endDate || null,
      salaryExpectation: this.salaryExpectationOptions?.find(level => level.id == this.form.getRawValue().salaryExpectationId)?.text,
      resumeId: this.resumeId()
    } as any as AddResumeEmployment;

    if (this.resumeId()) {
      this.isLoading.set(true);
      this.resumeService.addResumeEmployment({
        ...resumeEmployment
      }).subscribe({
        next: res => {
          this.isLoading.set(false);
          this.onResumeEmployment.emit(resumeEmployment)
          this.closeModal();
        }, error: res => {
          this.isLoading.set(false);
          Swal.fire({
            title: 'Error',
            text: 'Ocurrió un error al guardar el registro.',
            icon: 'error',
            confirmButtonColor: '#d33'
          });
        }
      })
    } else {
      this.onResumeEmployment.emit(resumeEmployment);
      this.closeModal();
    }
  }
}
